import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})


export class FooterDashboardGuard implements CanDeactivate<any> {
    canDeactivate(component: any): Observable<boolean> | Promise<boolean> | boolean {
        document.getElementsByTagName('footer')[0].classList.remove("footer-spacing-fix");
        return true;
    }
}
